import { CircleAlert } from 'lucide-react';
import { Link } from 'react-router';
import { urlConfig } from '@/urls';
import { Card, CardHeader, CardTitle } from '../common/card';
import { requiredFields } from '@/data/club/required-fields';
import { Button } from '@repo/ui/components/button';
import type { Club } from '@repo/shared-types';

export function MissingData({ club }: { club: Club }) {
  const missingFields = requiredFields.filter((field) => !club[field as keyof Club]);
  if (missingFields.length === 0) {
    return null;
  }

  return (
    <Card className="col-span-1 md:col-span-2 lg:col-span-3 xl:col-span-4">
      <CardHeader>
        <CircleAlert className="h-5 w-5 text-red" />
        <CardTitle>Tu club tiene datos faltantes</CardTitle>
        <div className="flex flex-1 items-center justify-end gap-2">
          <Button>
            <Link viewTransition to={urlConfig(club.id)}>
              Completar datos
            </Link>
          </Button>
        </div>
      </CardHeader>
    </Card>
  );
}
